import { render, staticRenderFns } from "./importDeclarations.vue?vue&type=template&id=2f8cb654&scoped=true"
import script from "./importDeclarations.vue?vue&type=script&lang=js"
export * from "./importDeclarations.vue?vue&type=script&lang=js"
import style0 from "./importDeclarations.vue?vue&type=style&index=0&id=2f8cb654&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8cb654",
  null
  
)

export default component.exports